export const createDocumentCards = ({
  visaStats,
  passportStats,
  eidStats,
  insuranceStats,
  accessCardStats,
  labourCardStats,
  employementVisa,
  employeePassport,
  emiratesId,
  medicalInsurance,
  dmccAccessCard,
  labourCard,
}) => [
  {
    cardData: employementVisa,
    stats: visaStats,
    route: "/visadetails",
    stateKey: "visaData",
    className: "employementVisa",
  },
  {
    cardData: employeePassport,
    stats: passportStats,
    route: "/passportdetails",
    stateKey: "passportData",
    className: "employeePassport",
  },
  {
    cardData: emiratesId,
    stats: eidStats,
    route: "/emiratesiddetails",
    stateKey: "eidData",
    className: "emiratesId",
  },
  {
    cardData: medicalInsurance,
    stats: insuranceStats,
    route: "/insurancecarddetails",
    stateKey: "insuranceData",
    className: "medicalInsurance",
  },
  // {
  //   cardData: dmccAccessCard,
  //   stats: accessCardStats,
  //   route: "/accesscarddetails",
  //   stateKey: "accessCardData",
  //   className: "dmccAccess",
  // },
  {
    cardData: labourCard,
    stats: labourCardStats,
    route: "/labourcarddetails",
    stateKey: "labourCardData",
    className: "labourCard",
  },
];